import type { ReactEventHandler } from 'react';
import { Image } from 'palette/Image';
import { IColor, Thumbnail as ThumbnailObject } from 'palette/ProductCard/types/productData';
import { useProductCardContext } from '../ProductCardContext';
import '../styles/Thumbnail.scss';

interface ThumbnailProps {
    thumb: ThumbnailObject;
    onLoad?: ReactEventHandler<HTMLImageElement>;
    color: IColor | null;
}

function Thumbnail({
    thumb,
    onLoad,
    color,
}: ThumbnailProps) {
    const { setActiveVariantId, setIsThumbnailsHovered, isLazy } = useProductCardContext();
    const { url, img, variantId } = thumb;

    const mouseEnterHandler = () => {
        setActiveVariantId(variantId);
        setIsThumbnailsHovered(true);
    };

    return (
        <a
            key={url}
            aria-label={color?.name || undefined}
            className="palette-product-card-thumbnail"
            href={url}
            onMouseEnter={mouseEnterHandler}
        >
            <Image
                {...isLazy && { loading: 'lazy' }}
                {...img.attributes}
                {...!!onLoad && {
                    onLoad,
                }}
            />
        </a>
    );
}

export default Thumbnail;
